/* Stable-ID grammar.
 *
 * Authority: 06-content-pipeline.md §2.1/§3.2 (schema authority), confirmed by
 * DR-10 — kebab-case with hyphen prefixes wins over 04's snake examples. These
 * regexes ARE the enforcing definition; the validator and the branded types below
 * both read from here so the two can never drift (R9).
 *
 * IDs are permanent and never reused. A material change to a Card or QuizItem
 * requires a NEW id; absence from the next release is retirement (04 §1.2).
 */
export const ID_PATTERNS = {
    /** P01–P16, fixed reference data. */
    domain: /^P(0[1-9]|1[0-6])$/,
    /** C1–C5, fixed reference data. */
    cluster: /^C[1-5]$/,
    topic: /^t-[a-z0-9][a-z0-9-]{1,61}$/,
    unit: /^u-[a-z0-9][a-z0-9-]{1,61}$/,
    card: /^c-[a-z0-9-]{2,62}$/,
    quizItem: /^q-[a-z0-9-]{2,62}$/,
    missionStep: /^s-[a-z0-9-]{2,62}$/,
    expedition: /^e-[a-z0-9-]{2,62}$/,
    /** YYYY.MM.DD-<seq>, seq restarts per day (DR-11). */
    releaseId: /^\d{4}\.\d{2}\.\d{2}-\d+$/,
    /** Client-minted idempotency keys: lowercase UUIDv4. */
    uuidV4: /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/,
};
export function isValidId(kind, value) {
    return typeof value === 'string' && ID_PATTERNS[kind].test(value);
}
/**
 * Cluster membership is a fixed function of Domain (04 §2.2, 06 §3.1).
 * Validation rule V9 enforces exactly this mapping — it is never authored freely.
 */
export const CLUSTER_OF_DOMAIN = Object.freeze({
    P01: 'C1', P02: 'C1',
    P03: 'C2', P04: 'C2',
    P05: 'C3', P06: 'C3', P07: 'C3', P08: 'C3', P09: 'C3',
    P10: 'C4', P11: 'C4', P12: 'C4',
    P13: 'C5', P14: 'C5', P15: 'C5', P16: 'C5',
});
export const CLUSTER_NAMES = Object.freeze({
    C1: 'Foundations of Thought & Math',
    C2: 'Engineering & Data',
    C3: 'Models & Methods',
    C4: 'Architecture & Operations',
    C5: 'Product, Value & Society',
});
export const ALL_DOMAIN_IDS = Object.freeze(Object.keys(CLUSTER_OF_DOMAIN));
export const ALL_CLUSTER_IDS = Object.freeze(Object.keys(CLUSTER_NAMES));
export function clusterOfDomain(domainId) {
    return CLUSTER_OF_DOMAIN[domainId];
}
//# sourceMappingURL=ids.js.map